import { IncapacitatedReportCriteria } from '@src/main/modules/reports/incapacitated/domain/incapacitated-report.interface';

export const parseIncapacitatedReportCriteria = (
  criteria: IncapacitatedReportCriteria,
): Record<string, string | number> => {
  const params: Record<string, string | number> = {
    offset: criteria.offset,
    limit: criteria.limit,
  };

  if (criteria.flightNumber) params.flight_num = criteria.flightNumber;
  if (criteria.departureAirport) params.flight_departure = criteria.departureAirport;
  if (criteria.arrivalAirport) params.flight_arrival = criteria.arrivalAirport;
  if (criteria.aircraftRegistration) params.flight_mat = criteria.aircraftRegistration;
  if (criteria.payroll) params.payroll = criteria.payroll;
  if (criteria.flightSince) params.flightSince = criteria.flightSince;
  if (criteria.flightUntil) params.flightUntil = criteria.flightUntil;
  if (criteria.sortField) params.sortField = criteria.sortField;
  if (criteria.sortOrder) params.sortOrder = criteria.sortOrder;

  return params;
};
